module.exports = __webpack_public_path__ + "media/images/emblems/GW-SG-Ebnat-Kappel-fccc9773317eef132ddc6d06bc0d46ac.png";